import React from 'react'
import classNames from 'classnames'
import { Loading, Icon, Text } from 'components'
import styles from './Button.module.scss'

const colorIcon = (darkColor, type, classIcon, disabled, textColor) => {
  if (disabled) {
    return 'whiteColor'
  }

  if (classIcon) {
    return classIcon
  }

  if (type === 'outline') {
    if (darkColor) {
      return 'darkColor'
    }
    return 'primaryColor'
  }

  if (textColor) {
    return textColor
  }

  return 'whiteColor'
}

const Button = ({
  showButton = true,
  children = '',
  onClick,
  disabled = false,
  type = 'filled',
  darkColor = false,
  textColor = 'whiteColor',
  redColor = false,
  whiteColor = false,
  backgroundColor = 'primaryColor',
  iconPosition = '',
  icon = 'bell',
  classIcon = '',
  fontSize = 'small',
  className = '',
  isLoading = false,
  textLoading = '',
  name = undefined,
  id = '',
  bold = false,
}) => {
  return (
    showButton && (
      <button
        name={name}
        type="button"
        onClick={onClick}
        className={classNames(
          className,
          styles[type],
          styles[`direction-${iconPosition}`],
          styles[`font-${fontSize}`],
          [className],
          {
            [styles[`background-${backgroundColor}`]]:
              type === 'filled' && !disabled,
            [styles[`border-${backgroundColor}`]]:
              type === 'outline' && !disabled,
            [styles[redColor ? 'redBackground' : 'primaryBackground']]:
              type === 'filled' && !disabled,
            [styles[whiteColor ? 'whiteBackground' : 'primaryBackground']]:
              type === 'filled' && !disabled,
            [styles.paddingButton]: iconPosition,
            [styles.disabled]: disabled,
            [styles.bold]: bold,
            [styles[`text-${textColor}`]]: textColor && !disabled,
          }
        )}
        disabled={disabled}
        id={id}
      >
        {isLoading ? (
          <span className={styles.containerLoading}>
            <Loading size="small" />
            {textLoading && (
              <Text className={styles.textLoading}>{textLoading}</Text>
            )}
          </span>
        ) : (
          <>
            {iconPosition && (
              <div className={styles[iconPosition]}>
                <Icon
                  color={colorIcon(
                    darkColor,
                    type,
                    classIcon,
                    disabled,
                    textColor
                  )}
                  type={icon}
                  size={16}
                />
              </div>
            )}
            {children}
          </>
        )}
      </button>
    )
  )
}

export default React.memo(Button)
